import React from "react";
import {connect} from "react-redux";
import {Breadcrumb, Panel, Media, Image, Table} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import Loading from "components/Loading";
import Request from "request";
import $ from "jquery";
import moment from "moment";
import {getClientAvatar, getClientNickname, getHumanDuration} from "tools";
import "./style";

class ClientStatistic extends React.Component {
	state = {
		isLoading: true,
		statistic: null,
		registrationFields: null,
		infoFieldNames: null
	};

	componentDidMount() {
		const {event} = this.props;
		const {clientId} = this.props?.match?.params;

		$.when(
            Request.get(`/api/cp/event/${event.eventPassword}/statistic/client/${clientId}`)
                .then(statistic => this.setState({statistic})),
            Request.get(`/api/cp/client/registration/field`)
                .then(registrationFields => {
                    const infoFieldNames = {
                        nickname: 'Имя'
                    };
                    registrationFields.forEach(field => {
                        infoFieldNames[field.name] = field.label_ru;
                    });
                    this.setState({registrationFields, infoFieldNames});
                })
        )
        .then(() => console.log('done'))
        .catch(() => {})
        .then(() => this.setState({isLoading: false}))
	}

	render() {
		const event = this.props.event;
		const {statistic, isLoading, infoFieldNames} = this.state;

		const accountTypes = {
			vk: 'Вконтакте',
			facebook: 'Facebook',
			twitter: 'Twitter',
			mailru: 'Mail.ru',
			ok: 'OK.ru',
			email: 'COMDI',
			guest: 'Гость'
		};

		if(isLoading) return <Loading>Загрузка информации о зрителе</Loading>;
		if(!statistic) return <div>Not Found</div>;

		return (
			<section>
				<Breadcrumb>
					<LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
					<LinkContainer to={`/event/${event.eventPassword}/client`}><Breadcrumb.Item>Зрители</Breadcrumb.Item></LinkContainer>
					<Breadcrumb.Item active>{getClientNickname(statistic.client, event.moduleAuth.nickname)}</Breadcrumb.Item>
				</Breadcrumb>

				<section>
                    <h4>Регистрационные данные</h4>
                    <Panel>
                        {Object.keys(statistic.client.info).map((key) => (
                            infoFieldNames[key]
                                ? <p key={key}>
                                    <span>{infoFieldNames[key]}</span>:
                                    {key === 'konturFocusOrg'
                                        ? <>
                                            <span className="client-statistic-info">
                                                Название организации: {statistic.client.info[key].organizationName || "Не указано"}
                                            </span>
                                            <span className="client-statistic-info">
                                                ИНН: {statistic.client.info[key].organizationInn || "Не указано"}
                                            </span>
                                            <span className="client-statistic-info">
                                                КПП: {statistic.client.info[key].organizationKpp || "Не указано"}
                                            </span>
                                        </>
                                        : <span> {statistic.client.info[key] || "Не указано"}</span>
                                    }
                                </p>
                                : null
                        ))}
                    </Panel>
				</section>

				<section>
                    <h4>Аккаунты</h4>
					{statistic.clients.map(account =>
						<Panel className="client-statistic-account" key={account.id}>
							<Media>
								<Media.Left>
									<Image src={getClientAvatar(account)} />
								</Media.Left>
								<Media.Body>
									<Media.Heading>{getClientNickname(account, event.moduleAuth.nickname)}</Media.Heading>
									<div>Сервис: <a href={account.info.link} target="_blank">{accountTypes[account.type] || account.type}</a></div>
									{account.info.email && <div>eMail: {account.info.email}</div>}
								</Media.Body>
							</Media>
						</Panel>
					)}
				</section>

                {statistic.sessions instanceof Array && statistic.sessions.length > 0 &&
                    <section>
                        <h4>Просмотры</h4>
                        <Table>
                            <thead>
                            <tr>
                                <th>Время входа</th>
                                <th>Время выхода</th>
                                <th>Продолжительность</th>
                            </tr>
                            </thead>
                            <tbody>
                            {statistic.sessions.map(session => (
                                <tr key={session.id}>
                                    <td>{moment.unix(session.timeStart).format('YYYY-MM-DD HH:mm:ss')}</td>
                                    <td>{session.timeStop ? moment.unix(session.timeStop).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                                    <td>{getHumanDuration((session.timeStop || moment().unix()) - session.timeStart, true)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </section>
                }

                {statistic.events instanceof Array && statistic.events.length > 0 &&
                    <section>
                        <h4>Просмотренные трансляции</h4>
                        <Table>
                            <thead>
                            <tr>
                                <th>Название</th>
                            </tr>
                            </thead>
                            <tbody>
                            {statistic.events.map(event =>
                                <tr key={event.id}>
                                    <td>
                                        <a href={`/${event.moduleMain.frontendPage === 'platform' ? 'event' : 'watch'}/${event.eventKey}`} target="_blank">{event.name}</a>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </section>
                }
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(ClientStatistic);
